import { useId } from 'react';

/**
 * Le monogramme OX vectoriel : un seul ruban, argent vers violet, le brin
 * descendant passant devant. Mêmes tracés que `design/logo/ox-mark.svg`.
 */
export function OxMark({
  className,
  title,
}: {
  readonly className?: string;
  readonly title?: string;
}) {
  const id = useId();
  const base = `${id}-base`;
  const front = `${id}-front`;
  const sheen = `${id}-sheen`;
  const clip = `${id}-clip`;

  return (
    <svg
      className={className}
      viewBox="0 0 206 100"
      role={title ? 'img' : undefined}
      aria-label={title}
      aria-hidden={title ? undefined : true}
    >
      <defs>
        <linearGradient id={base} gradientUnits="userSpaceOnUse" x1="0" y1="0" x2="206" y2="0">
          <stop offset="0" stopColor="#F4F3FB" />
          <stop offset="0.3" stopColor="#D6D0F8" />
          <stop offset="0.56" stopColor="#9C86FF" />
          <stop offset="1" stopColor="#6C4CFF" />
        </linearGradient>
        <linearGradient id={front} gradientUnits="userSpaceOnUse" x1="97" y1="23" x2="196" y2="100">
          <stop offset="0" stopColor="#C4B8FF" />
          <stop offset="0.45" stopColor="#8C72FF" />
          <stop offset="1" stopColor="#6646F2" />
        </linearGradient>
        <linearGradient id={sheen} gradientUnits="userSpaceOnUse" x1="0" y1="0" x2="0" y2="100">
          <stop offset="0" stopColor="#FFFFFF" stopOpacity="0.5" />
          <stop offset="0.38" stopColor="#FFFFFF" stopOpacity="0" />
          <stop offset="0.68" stopColor="#0A0A0F" stopOpacity="0" />
          <stop offset="1" stopColor="#0A0A0F" stopOpacity="0.38" />
        </linearGradient>
        <clipPath id={clip}>
          <rect x="-20" y="0" width="260" height="100" />
        </clipPath>
      </defs>
      <g clipPath={`url(#${clip})`} fill="none">
        <path
          d="M196 -6 L97.6 76.6 A50 39 0 1 1 97.6 23.4"
          stroke={`url(#${base})`}
          strokeWidth="22"
        />
        <path
          d="M196 -6 L97.6 76.6 A50 39 0 1 1 97.6 23.4"
          stroke={`url(#${sheen})`}
          strokeWidth="22"
        />
        <path d="M121.4 35.5 L145.2 55.5" stroke="#0A0A0F" strokeOpacity="0.6" strokeWidth="26" />
        <path d="M96.8 22.8 L196 106" stroke={`url(#${front})`} strokeWidth="22" />
        <path d="M96.8 22.8 L196 106" stroke={`url(#${sheen})`} strokeWidth="22" />
      </g>
    </svg>
  );
}
